import React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {onDesktop, p} from "@pg-design/helpers-css";
import {TrashIcon} from "@pg-design/icons-module";
import {Link} from "@pg-design/link-module";
import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {useUserDevice} from "@pg-mono/user-device";
import {cellWidthPrint} from "@pg-rp/comparison-table";

import {useMyOffersFavourites} from "../../../my_offers/hooks/use_my_offers_favourites";
import {getOfferTypeNameCapital} from "../../../offer/helpers/OfferType";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {useComparisonToolContext} from "../../contexts/comparison_tool_context";

interface IProps {
    property: IPropertyDetail;
    tableItemIndex: number;
    showRemoveButton: boolean;
}

export const TableCellHeader = (props: IProps) => {
    const {tableItemIndex} = props;
    const theme = useTheme();
    const {isMobile} = useUserDevice();
    const {removeFavouriteProperty} = useMyOffersFavourites();
    const {selectPropertyPlan} = useComparisonToolContext();
    const property = props.property;

    const imgSrc = isMobile ? property.offer.main_image.m_img_155x87 : property.offer.main_image.m_img_224x147;
    const address = `${getOfferTypeNameCapital(property.offer.type)}, ${property.offer.address}`;
    const propertyLink = rpAppLink.property.detail.base({
        vendorSlug: property.offer.vendor.slug,
        offerSlug: property.offer.slug,
        offerId: property.offer.id,
        propertyId: property.id
    });

    const onPlanClick = () => {
        selectPropertyPlan({
            propertyId: property.id,
            propertyTableIndex: tableItemIndex
        });
    };

    const onRemoveClick = () => {
        removeFavouriteProperty(property.id);
    };

    return (
        <>
            <div css={imgWrapStyle}>
                <Link href={propertyLink}>
                    <Picture
                        sources={[
                            {minWidthPX: 0, src: imgSrc, height: 90, width: 131},
                            {minWidthPX: theme.breakpoints.numeric.md, src: imgSrc, height: 90, width: 160}
                        ]}
                        alt="image"
                    />
                </Link>
                {props.showRemoveButton && (
                    <div css={removeIconPositioner}>
                        <span css={removeIconWrapper} onClick={onRemoveClick}>
                            <TrashIcon size="1.5" fill="#fff" wrapperColor={theme.colors.gray["800"]} wrapperSize="2.4" />
                        </span>
                    </div>
                )}
            </div>
            <div css={contentStyle}>
                <Text as="span" css={addressStyle} variant="info_txt_2">
                    {address}
                </Text>
                <div css={planButtonWrap}>
                    <Button size="x-small" variant="highlight_primary" onClick={onPlanClick}>
                        Pokaż rzut
                    </Button>
                </div>
            </div>
        </>
    );
};

//  Styles
const headerCellWidth = css`
    width: 13.1rem;
    height: 9rem;

    ${onDesktop(css`
        width: 16rem;
        height: 9rem;
    `)};
`;

const contentStyle = () => css`
    ${p(2, 1, 1, 1)}
    ${headerCellWidth}
    display: flex;
    flex-direction: column;
    row-gap: 0.8rem;
`;

const addressStyle = (theme: Theme) => css`
    color: ${theme.colors.secondary};
    min-height: 4.8rem;

    ${onDesktop(css`
        min-height: 3.6rem;
    `)};

    @media print {
        ${cellWidthPrint};
    }
`;

const imgWrapStyle = css`
    position: relative;
    overflow: hidden;
    ${headerCellWidth}
`;

const planButtonWrap = css`
    display: inline-flex;

    @media print {
        display: none;
    }
`;

const removeIconPositioner = css`
    position: absolute;
    top: 0.5rem;
    right: 0.6rem;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const removeIconWrapper = css`
    cursor: pointer;
`;
import React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {onDesktop, p} from "@pg-design/helpers-css";
import {TrashIcon} from "@pg-design/icons-module";
import {Link} from "@pg-design/link-module";
import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {useUserDevice} from "@pg-mono/user-device";
import {cellWidthPrint} from "@pg-rp/comparison-table";

import {useMyOffersFavourites} from "../../../my_offers/hooks/use_my_offers_favourites";
import {getOfferTypeNameCapital} from "../../../offer/helpers/OfferType";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {useComparisonToolContext} from "../../contexts/comparison_tool_context";

interface IProps {
    property: IPropertyDetail;
    tableItemIndex: number;
    showRemoveButton: boolean;
}

export const TableCellHeader = (props: IProps) => {
    const {tableItemIndex} = props;
    const theme = useTheme();
    const {isMobile} = useUserDevice();
    const {removeFavouriteProperty} = useMyOffersFavourites();
    const {selectPropertyPlan} = useComparisonToolContext();
    const property = props.property;

    const imgSrc = isMobile ? property.offer.main_image.m_img_155x87 : property.offer.main_image.m_img_224x147;
    const address = `${getOfferTypeNameCapital(property.offer.type)}, ${property.offer.address}`;
    const propertyLink = rpAppLink.property.detail.base({
        vendorSlug: property.offer.vendor.slug,
        offerSlug: property.offer.slug,
        offerId: property.offer.id,
        propertyId: property.id
    });

    const onPlanClick = () => {
        selectPropertyPlan({
            propertyId: property.id,
            propertyTableIndex: tableItemIndex
        });
    };

    const onRemoveClick = () => {
        removeFavouriteProperty(property.id);
    };

    return (
        <>
            <div css={imgWrapStyle}>
                <Link href={propertyLink}>
                    <Picture
                        sources={[
                            {minWidthPX: 0, src: imgSrc, height: 90, width: 131},
                            {minWidthPX: theme.breakpoints.numeric.md, src: imgSrc, height: 90, width: 160}
                        ]}
                        alt="image"
                    />
                </Link>
                {props.showRemoveButton && (
                    <div css={removeIconPositioner}>
                        <span css={removeIconWrapper} onClick={onRemoveClick}>
                            <TrashIcon size="1.5" fill="#fff" wrapperColor={theme.colors.gray["800"]} wrapperSize="2.4" />
                        </span>
                    </div>
                )}
            </div>
            <div css={contentStyle}>
                <Text as="span" css={addressStyle} variant="info_txt_2">
                    {address}
                </Text>
                <div css={planButtonWrap}>
                    <Button size="x-small" variant="highlight_primary" onClick={onPlanClick}>
                        Pokaż rzut
                    </Button>
                </div>
            </div>
        </>
    );
};

//  Styles
const headerCellWidth = css`
    width: 13.1rem;
    height: 9rem;

    ${onDesktop(css`
        width: 16rem;
        height: 9rem;
    `)};
`;

const contentStyle = () => css`
    ${p(2, 1, 1, 1)}
    ${headerCellWidth}
    display: flex;
    flex-direction: column;
    row-gap: 0.8rem;
`;

const addressStyle = (theme: Theme) => css`
    color: ${theme.colors.secondary};
    min-height: 4.8rem;

    ${onDesktop(css`
        min-height: 3.6rem;
    `)};

    @media print {
        ${cellWidthPrint};
    }
`;

const imgWrapStyle = css`
    position: relative;
    overflow: hidden;
    ${headerCellWidth}
`;

const planButtonWrap = css`
    display: inline-flex;

    @media print {
        display: none;
    }
`;

const removeIconPositioner = css`
    position: absolute;
    top: 0.5rem;
    right: 0.6rem;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const removeIconWrapper = css`
    cursor: pointer;
`;
